
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/van/campervan",
      function () {
        return require("private-next-pages/wheels/van/campervan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/van/campervan"])
      });
    }
  